import { render } from "./EditItem3.vue?vue&type=template&id=7585903e&scoped=true"
import script from "./EditItem3.vue?vue&type=script&lang=js"
export * from "./EditItem3.vue?vue&type=script&lang=js"

import "./EditItem3.vue?vue&type=style&index=0&id=7585903e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7585903e"]])

export default __exports__